import React, { Component } from "react";
import SmallFooterMenuItem from "./SmallFooterMenuItem";

export default class SmallFooterMenu extends Component {
  render() {
    return this.props.FooterLinks.map((footerMenu, footerMenuCtr) => {
      return (
        <SmallFooterMenuItem
          key={footerMenuCtr}
          footerMenu={footerMenu}
          isLapsed={this.props.isLapsed}
          isInternational={this.props.isInternational}
          isSaga={this.props.isSaga}
          isHOL={this.props.isHOL}
          pageArea={this.props.pageArea}
          featureFlagEP={this.props.featureFlagEP}
          urlInbox={this.props.urlInbox}
          IsInternalView={this.props.IsInternalView}
        />
      );
    });
  }
}
